import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@material-ui/core';
import Plus from '../../../../assets/plus.svg';
import './style.scss';

export const MailsList = ({ title, addMail, children, ...props }) => {
	const { t } = useTranslation();
	
	return (
		<div {...props}>
			<div className='addNewUserForm' style={{ display: 'flex', flexDirection: 'row' }}>
				<div style={{ marginTop: '8px' }}>{title}</div>
				<Button 
					disableRipple
					className='add-user-btn' 
					onClick={addMail}
				>
					<div style={{ paddingLeft: '0px', display: 'flex' }}>
						<img src={Plus} alt={Plus} />
						<div style={{ marginLeft: '10px' }}>{t('additionalEmails.add_mail')}</div>
					</div>
				</Button>
			</div>

			<div>{children}</div>
		</div>
	);
};
